import { withResolvedHref } from '@faro/app-context';
import { FaroMenu, FaroNavigationTree } from '@faro/design-system';
import { LinkIcon, Trash2Icon } from '@faro/icons';
import { ReactNode } from 'react';

const LinkWithResolvedHref = withResolvedHref(FaroNavigationTree.Node);

export interface UserLink {
    readonly id: string;
    readonly label: string;
    readonly url: string;
}

export interface UserLinkNavProps {
    readonly userLink: UserLink;
    onDelete: (id: string) => void;
}

function UserLinkNav(props: UserLinkNavProps): ReactNode {
    const { userLink, onDelete } = props;

    function openLink() {
        const newWindow = window.open(userLink.url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.opener = null; // Extra precaution
        }
    }

    const menuOptions = [
        <FaroMenu.Item
            key="delete"
            left={<Trash2Icon />}
            onClick={() => {
                onDelete(userLink.id);
            }}
            color="danger"
            data-automation-id="deleteUserLinkMenuItem"
        >
            Delete
        </FaroMenu.Item>,
    ];
    const controls = <FaroNavigationTree.NodeMenu>{menuOptions}</FaroNavigationTree.NodeMenu>;

    return (
        <LinkWithResolvedHref
            key={userLink.id}
            id={userLink.id}
            data-automation-role="userLinkNav"
            label={userLink.label}
            controls={controls}
            onSelect={openLink}
            icon={<LinkIcon />}
        ></LinkWithResolvedHref>
    );
}

export default UserLinkNav;
